/**
 * The plot of the Day timeline's chart: 24 hour columns over hairline
 * gridlines at clean ticks, the y-axis on the left (drops or SMS), the
 * Danish hour every third column underneath.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { instantDk } from '../../../utils/clock/dk-label';
import { type HourBucket, niceTicks } from './day-hours';
import { type DayMetric, HourColumn, valueOf } from './HourColumn';

const COLS = { gridTemplateColumns: 'repeat(24, minmax(0, 1fr))' };
const PLOT = 'relative h-[168px]';

export const DayPlot: FC<{ hours: HourBucket[]; metric: DayMetric }> = ({ hours, metric }) => {
  const ticks = niceTicks(Math.max(...hours.map((h) => valueOf(h, metric))));
  const max = ticks[ticks.length - 1];
  const at = (v: number) => `${(v / max) * 100}%`;
  return (
    <div className="grid grid-cols-[52px_1fr] gap-x-2" data-testid="day-plot">
      <div className={PLOT} aria-hidden>
        {ticks.map((t) => (
          <span key={t} className="absolute right-0 translate-y-1/2 font-mono text-[10px] tabular-nums text-muted-foreground" style={{ bottom: at(t) }}>
            {t.toLocaleString('en-US')}
          </span>
        ))}
      </div>
      <div className={`${PLOT} border-b border-border`}>
        {ticks.slice(1).map((t) => (
          <span key={t} className="absolute inset-x-0 border-t border-border/50" style={{ bottom: at(t) }} aria-hidden />
        ))}
        <div className="absolute inset-0 grid" style={COLS}>
          {hours.map((h) => (
            <HourColumn key={h.index} hour={h} metric={metric} max={max} />
          ))}
        </div>
      </div>
      <span className="pt-1 text-right text-[10px] text-muted-foreground">🇩🇰</span>
      <div className="grid pt-1" style={COLS} aria-hidden>
        {hours.map((h) => (
          <span key={h.index} className="text-center font-mono text-[10px] tabular-nums text-muted-foreground">
            {h.index % 3 === 0 ? instantDk(h.startIso).label : ''}
          </span>
        ))}
      </div>
    </div>
  );
};
